import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./computo-videoconferencia.css";
import computo1 from "./img-domotic/computoyvideoconfierencia.png"
import computo2 from "./img-domotic/computoyvideoconfierencia.png"
import computo3 from "./img-domotic/computoyvideoconfierencia.png"

import microsoft from "./img-domotic/computoyvideoconfierencia.png"
import zoom from "./img-domotic/computoyvideoconfierencia.png"
import cisco from "./img-domotic/computoyvideoconfierencia.png"
import logitech from "./img-domotic/computoyvideoconfierencia.png"

const ComputoVideoconferencia = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Cómputo y Videoconferencia
  const imagenesGaleria = [
    { src: computo1, alt: "Sala de videoconferencia profesional", caption: "Soluciones integrales para reuniones híbridas" },
    
  ];

  const servicios = [
    {
      icon: "💻",
      titulo: "Equipos Especializados",
      descripcion: "Estaciones de trabajo y dispositivos para colaboración.",
      features: ["Workstations profesionales", "Monitores interactivos", "Periféricos premium"]
    },
    {
      icon: "🎥",
      titulo: "Sistemas de VC",
      descripcion: "Videoconferencia empresarial con tecnología de punta.",
      features: ["Salas equipadas", "Cámaras PTZ 4K", "Micrófonos inteligentes"]
    },
    {
      icon: "🔄",
      titulo: "Colaboración Híbrida",
      descripcion: "Soluciones para equipos distribuidos y presenciales.",
      features: ["Pizarras digitales", "Control centralizado", "Integración multiplataforma"]
    },
    {
      icon: "☁️",
      titulo: "Espacios Inteligentes",
      descripcion: "Tecnología para salas de juntas y aulas virtuales.",
      features: ["Sensores IoT", "Automatización", "Analítica de uso"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Videoconferencia",
      items: [
        "Salas ejecutivas",
        "Sistemas todo-en-uno",
        "Soluciones para aulas",
        "Videowalls corporativos"
      ]
    },
    {
      categoria: "Equipamiento",
      items: [
        "Workstations gráficas",
        "Displays interactivos",
        "Sistemas de audio",
        "Control táctil"
      ]
    },
    {
      categoria: "Software",
      items: [
        "Plataformas colaborativas",
        "Gestión de dispositivos",
        "Analítica de reuniones",
        "Integración con UC"
      ]
    }
  ];

  const marcas = [
    { nombre: "Microsoft Teams", logo: microsoft },
    { nombre: "Zoom Rooms", logo: zoom },
    { nombre: "Cisco Webex", logo: cisco },
    { nombre: "Logitech", logo: logitech },
    { nombre: "Poly", logo: "/marcas/poly.png" },
    { nombre: "Crestron", logo: "/marcas/crestron.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.computo-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="computo-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="computo-hero">
        <div className="computo-hero-content">
          <h1 className="computo-hero-title">Cómputo y Videoconferencia</h1>
          <p className="computo-hero-subtitle">
            Soluciones tecnológicas para la colaboración moderna
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="computo-gallery computo-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="computo-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="computo-gallery-img"
            />
            <div className="computo-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>


      {/* Tipos de Soluciones */}
      
    {/* Sección de Características con Imágenes de Fondo */}
    <section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Nuestras Soluciones en Computo y Video Conferencia</h2>
    <p className="ryn-features-subtitle">Tecnología avanzada para reuniones, conferencias y ofimatica</p>
    
    <div className="ryn-features-grid">
      {/* Característica 1 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">Computo y Video Conferencia</h3>
          <ul className="ryn-feature-list">
            <li>Computadores, proyectores, impresoras, servidores</li>
            <li>Sistemas para video conferencia: equipos y licencias</li>
          </ul>
        </div>
      </div>
      
   
    </div>
  </div>
</section>  



     

    </div>
  );
};

export default ComputoVideoconferencia;